import './styles.scss';

export default {
    name: 'LoadingSubscriptionModal'
};